// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"579":"06156f4a","645":"06156f4a"}[chunkId] + ".css";
};